import * as firebase from 'firebase'
import 'firebase/firestore'
import setup from './setup'

export const firebaseui = require('firebaseui');

setup(firebase)

export default firebase
export const firestore = firebase.firestore()
export const database = firebase.database()
export const auth = firebase.auth()
export const storage = firebase.storage()

// Export your models here. Example:
export const userById = id => db.collection('users').doc(id)



// WEBPACK FOOTER //
// ./fire/index.js